import type { SVGProps } from 'react';

const SvgChild = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m17.71 14.29-3-3a.996.996 0 1 0-1.41 1.41l1.29 1.29H8v-7c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1h7.59l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3-3a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgChild;
